import {
  getRangeBefore,
  getRangeFromBlockStart,
  getText,
  isCollapsed,
  isNodeTypeIn,
  unwrapNodesByType,
  setDefaults,
} from '@udecode/slate-plugins';

import linkElement from './element';
import {
  upsertLinkAtSelection,
  wrapLink,
  setLink,
  unwrapLink,
} from './transforms';
import isUrl from '../../../../utils/isUrl';

const upsertLink = (editor, url, options) => {
  const { at, link } = setDefaults(options, linkElement);
  unwrapNodesByType(editor, link.type, { at });

  const newSelection = editor.selection;

  wrapLink({
    editor,
    url,
    options: {
      at: {
        ...at,
        focus: newSelection.focus,
      },
    },
  });
};

const withLink = options => editor => {
  const { link } = setDefaults(options, linkElement);
  const { insertData, insertText } = editor;

  editor.insertText = text => {
    if (text === ' ' && isCollapsed(editor.selection)) {
      const { selection } = editor;

      const rangeFromBlockStart = getRangeFromBlockStart(editor);
      const textFromBlockStart = getText(editor, rangeFromBlockStart);

      if (rangeFromBlockStart && isUrl(textFromBlockStart)) {
        upsertLink(editor, textFromBlockStart, {
          at: rangeFromBlockStart,
        });
        return insertText(text);
      }

      const beforeWordRange = getRangeBefore(editor, selection, {
        matchString: ' ',
        skipInvalid: true,
        afterMatch: true,
        multiPaths: true,
      });

      if (beforeWordRange) {
        const beforeWordText = getText(editor, beforeWordRange);

        if (isUrl(beforeWordText)) {
          upsertLink(editor, beforeWordText, {
            at: beforeWordRange,
          });
        }
      }
    }

    insertText(text);
  };

  editor.insertData = data => {
    const text = data.getData('text/plain');

    if (text && isUrl(text) && !isNodeTypeIn(editor, link.type)) {
      upsertLinkAtSelection(editor, text, {
        link,
      });

      editor.insertText(' ');
    } else {
      insertData(data);
    }
  };

  editor.wrapLink = wrapLink;
  editor.upsertLinkAtSelection = upsertLinkAtSelection;
  editor.setLink = setLink;
  editor.unwrapLink = unwrapLink;

  return editor;
};

export default withLink;
